import React from 'react';
import classes from './Button.css';
import Aux from '../../hoc/Aux';


const button = (props) =>{
    let myButton = null;
    if(props.gameEnd){
        myButton = <button onClick = {props.click} className={classes.button}>Restart the Game{myButton}</button>
    }

    return (
        <Aux>
             {myButton}
        </Aux>
       
    )
}

export default button;


// WEBPACK FOOTER //
// ./src/components/Button/Button.js